import { render, staticRenderFns } from "./Active.vue?vue&type=template&id=5a0fa80c&scoped=true&"
import script from "./Active.vue?vue&type=script&lang=js&"
export * from "./Active.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fa80c",
  null
  
)

export default component.exports